
























import { computed, defineComponent, getCurrentInstance, ref } from "@vue/composition-api";
import { Group } from "@scrile/api-provider/dist/api/GroupsProvider";
import { $t } from "@/lib/i18nHelpers";
import { getMassMessageUrl } from "@/lib/urlHelpers";
import { BaseMenuItem } from "@/types";
import BaseIconButton from "@/components/BaseIconButton";
import BaseMenu from "@/components/BaseMenu";
import CreateGroupModal from "@/components/CreateGroupModal";
import GroupDeleteConfirmation from "./components/GroupDeleteConfirmation.vue";

export default defineComponent({
  name: "GroupMenu",
  components: {
    BaseMenu,
    CreateGroupModal,
    GroupDeleteConfirmation,
    BaseIconButton,
  },
  props: {
    group: { type: Object as () => Group, required: true },
  },
  setup(props) {
    const vm = getCurrentInstance();
    const showDeleteConfirmation = ref(false);
    const showCreateModal = ref(false);

    const predefinedMenuItems: BaseMenuItem[] = [
      {
        name: "sendMassMessage",
        text: $t("Send mass message"),
      },
    ];
    const menuItems: BaseMenuItem[] = [
      ...predefinedMenuItems,
      {
        name: "rename",
        text: $t("Rename"),
      },
      {
        name: "delete",
        text: $t("Delete"),
      },
    ];

    const items = computed(() =>
      props.group.id === "blockedUsers" ? [] : props.group.system ? predefinedMenuItems : menuItems
    );

    const sendMassMessage = () => vm?.$router.push(getMassMessageUrl([props.group.id]));

    return { showDeleteConfirmation, showCreateModal, items, sendMassMessage };
  },
});
